// The video editor's timeline strings (components/Editor), under t('editor.rve.timeline.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  // Header: undo / redo
  undoTitle: 'Desfazer (Ctrl/Cmd + Z)',
  undoLabel: 'Desfazer a última ação',
  redoTitle: 'Refazer (Ctrl/Cmd + Shift + Z)',
  redoLabel: 'Refazer a última ação',
  // Header: splitting
  selectItemToSplit: 'Selecione um item para dividir no cursor de reprodução',
  selectOneItemToSplit: 'Selecione apenas um item para dividir',
  movePlayheadToSplit: 'Mova o cursor de reprodução sobre o item selecionado para dividir',
  splitSelectedItem: 'Dividir o item selecionado no cursor de reprodução',
  clickItemsToSplit: 'Clique nos itens da linha do tempo para dividi-los',
  enableSplittingMode: 'Ativar modo de divisão',
  autoRemoveEmptyTracks: 'Remover faixas vazias automaticamente',
  enableAutoRemoveEmptyTracks: 'Ativar a remoção automática de faixas vazias',
  // Header: playback
  jumpToStart: 'Ir para o início',
  jumpToEnd: 'Ir para o fim',
  playVideo: 'Reproduzir vídeo',
  pauseVideo: 'Pausar vídeo',
  // Header: aspect ratio
  aspectRatio: 'Proporção',
  widescreen: 'Widescreen',
  vertical: 'Vertical',
  square: 'Quadrado',
  portrait: 'Retrato',
  // Header: zoom and collapse
  zoomOut: 'Diminuir zoom',
  zoomIn: 'Aumentar zoom',
  resetZoom: 'Redefinir zoom',
  timelineZoom: 'Zoom da linha do tempo',
  expandTimeline: 'Expandir linha do tempo',
  collapseTimeline: 'Recolher linha do tempo',
  // Track handles
  reorderTrack: 'Reordenar faixa',
  enableMagnetic: 'Ativar linha do tempo magnética',
  disableMagnetic: 'Desativar linha do tempo magnética',
  deleteTrack: 'Excluir faixa',
  gapTitle: 'Espaço: {start}s - {end}s (clique para fechar)',
  // Item context menu
  duplicate: 'Duplicar',
  duplicateItems: 'Duplicar {n} itens',
  splitAtPlayhead: 'Dividir no cursor de reprodução',
  delete: 'Excluir',
  deleteItems: 'Excluir {n} itens',
  // Item labels
  videoLabel: 'VÍDEO',
  imageLabel: 'IMAGEM',
  textLabel: 'TEXTO',
  audioLabel: 'ÁUDIO',
  captionLabel: 'LEGENDA',
  subtitlesLabel: 'Legendas',
  stickerLabel: 'FIGURINHA',
  blurLabel: 'DESFOQUE',
  blurLevelLabel: 'DESFOQUE ({n}px)',
  unknownLabel: 'Desconhecido',
  typeLabel: 'Tipo: {type}',
  loading: 'Carregando...',
  noWaveform: 'Sem forma de onda',
  // Shared editor UI (ui/dialog, ui/sidebar)
  close: 'Fechar',
  toggleSidebar: 'Mostrar ou ocultar barra lateral',
};
